var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-panel',[_c('v-container',[_c('v-card',[_c('v-card-text',{staticClass:"display-2 text-center mt-5 primary white--text"},[_vm._v(" Countries ")])],1)],1),_c('v-container',[_c('v-card',[_c('v-list',_vm._l((_vm.items),function(i,k){return _c('v-list-item',{key:`target_${k}`},[_c('v-list-item-content',[_vm._v(_vm._s(i))])],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }